export function downloadStringAsFile(data: any, fileName:string, callback?: () => void): void {
    const text = `data:text/json;charset=utf-8,${encodeURIComponent(data)}`;
    const link = document.createElement("a");
    link.href = text;
    link.download = fileName;
    link.click();

    if (callback) {
        callback();
    }
}